module.exports = __webpack_public_path__ + "static/media/logo-enele-white.628c7b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-enele-white.png
// module id = 1660
// module chunks = 0